// Crevix Landing Page Mock Data

export const heroData = {
  headline: "Monetize Your Audience",
  subheadline: "Without Creating Products",
  description: "Crevix is your silent backend operator. We use AI to create digital products from your knowledge, handle sales, payments, and delivery - you just promote.",
  ctaText: "Get Monetized",
  stats: [
    { value: "40+", label: "Creators Partnered" },
    { value: "60%", label: "Revenue to Creators" },
    { value: "0", label: "Upfront Cost" },
    { value: "AI", label: "Powered Creation" }
  ]
};

export const howItWorksSteps = [
  {
    step: 1,
    title: "Sign Up Free",
    description: "Create your account and share your Instagram handle. No credit card required.",
    icon: "UserPlus"
  },
  {
    step: 2,
    title: "AI Creates Your Product",
    description: "Our AI identifies your monetizable knowledge and creates a polished digital product in hours, not weeks.",
    icon: "Sparkles"
  },
  {
    step: 3,
    title: "Get Your Link",
    description: "Receive a personalized sales page with everything set up — payments, delivery, support.",
    icon: "Link"
  },
  {
    step: 4,
    title: "Promote & Earn",
    description: "Add the link to your bio, create content, and watch the revenue flow in.",
    icon: "TrendingUp"
  }
];

export const creatorBenefits = [
  {
    title: "Zero Tech Hassle",
    description: "No tools to learn, no platforms to set up. We handle everything from product creation to customer support.",
    icon: "Zap"
  },
  {
    title: "One Link, All Sales",
    description: "A single link in your bio connects your audience to your products. Simple, clean, effective.",
    icon: "LinkIcon"
  },
  {
    title: "Passive Income",
    description: "Focus on creating content while your digital products sell automatically in the background.",
    icon: "Wallet"
  },
  {
    title: "Keep 60% Revenue",
    description: "Fair split with no hidden fees. You earn 60% of every sale, paid out weekly or monthly.",
    icon: "PiggyBank"
  },
  {
    title: "Full Support Handled",
    description: "Customer questions, refunds, technical issues — we manage it all so you don't have to.",
    icon: "HeadphonesIcon"
  },
  {
    title: "Instant Delivery",
    description: "Buyers get immediate access after payment. PDFs, videos, guides — delivered automatically.",
    icon: "Rocket"
  }
];

export const aiFeatures = {
  headline: "AI-Powered Product Creation",
  subheadline: "What takes weeks, we do in hours",
  description: "Our AI analyzes your content, identifies your unique expertise, and transforms it into polished digital products that your audience will love.",
  features: [
    {
      title: "Content Analysis",
      description: "AI scans your posts and stories to understand your niche and expertise",
      icon: "Search"
    },
    {
      title: "Product Generation",
      description: "Automatically creates guides, templates, and resources from your knowledge",
      icon: "FileText"
    },
    {
      title: "Sales Copy Writing",
      description: "Compelling product descriptions and sales pages written by AI",
      icon: "PenTool"
    },
    {
      title: "Continuous Optimization",
      description: "AI learns from sales data to improve conversions over time",
      icon: "BarChart3"
    }
  ]
};

export const testimonials = [
  {
    name: "Priya Sharma",
    handle: "@priya.fitness",
    niche: "Fitness Creator",
    quote: "I never thought I could sell digital products. Crevix created a workout guide from my posts and it's been selling on autopilot!",
    avatar: "PS"
  },
  {
    name: "Arjun Mehta",
    handle: "@studywith.arjun",
    niche: "Study Tips",
    quote: "The AI understood exactly what my audience needed. My study template pack was ready in 2 days. Insane.",
    avatar: "AM"
  },
  {
    name: "Sneha Reddy",
    handle: "@sneha.mindset",
    niche: "Mindset Coach",
    quote: "Zero tech skills needed. I just promote my link and Crevix handles everything else. Finally monetizing my knowledge!",
    avatar: "SR"
  }
];

export const faqData = [
  {
    question: "How does the revenue split work?",
    answer: "You keep 60% of every sale, Crevix takes 40%. This covers product creation, hosting, payments, delivery, and customer support. Early creators may qualify for a 70/30 split."
  },
  {
    question: "What kind of products does AI create?",
    answer: "Based on your niche and content, our AI creates digital products like PDF guides, templates, checklists, resource lists, and mini-courses. All tailored to what your audience wants."
  },
  {
    question: "How long does it take to get started?",
    answer: "Sign up takes 2 minutes. Our AI analyzes your content and creates your first product within 24-48 hours. You could be selling by the end of the week."
  },
  {
    question: "Do I need a large following?",
    answer: "Not at all! Crevix is designed for micro-creators with 1k-100k followers. An engaged audience matters more than size."
  }
];

export const footerData = {
  tagline: "Your silent backend operator for creator monetization.",
  links: [
    { label: "How It Works", href: "#how-it-works" },
    { label: "For Creators", href: "#benefits" },
    { label: "AI Features", href: "#ai-features" },
    { label: "FAQ", href: "#faq" }
  ],
  social: [
    { label: "Instagram", href: "https://www.instagram.com/crevixofficial/", icon: "Instagram" },
    { label: "Twitter", href: "https://www.instagram.com/crevixofficial/", icon: "Twitter" }
  ]
};
